import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface SubHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
	className?: string;
}

export function SubHeading({ children, className, ...rest }: SubHeadingProps) {
	return (
		<h4 className={cssClasses(css.subHeading, className)} {...rest}>
			{children}
		</h4>
	);
}
